import { BaseSearchAutocompleteCustom, BaseSearchStrategy } from "@/Common/Components/Search/BaseSearchAutocompleteCustom";
import { Ethnicities } from "@/Common/Models/Individuals/Enums/Ethnicity";
import { Ethnicity } from "@/Common/Models/UI/Ethnicity";
import { EthnicityDropdownItem } from "@/Common/Models/UI/Inputs/EthnicityDropdownItem";

class EthnicitySearchAutocompleteCustom extends BaseSearchAutocompleteCustom<Ethnicity> {
    protected defaultSearchStrategy = new EthnicitySearchSearchStrategy(Ethnicity.DropdownList());

    protected renderLabel(model: Ethnicity): string {
        return model.localKey;
    }

    protected searchStrategyRenderItem(model: Ethnicity, cssClass?: string): React.ReactNode {
        return <div className={cssClass}><span>{this.renderLabel(model)}</span></div>;
    }

    protected getItemId(model: Ethnicity): Ethnicities {
        return model.value;
    }
}

class EthnicitySearchSearchStrategy extends BaseSearchStrategy<Ethnicity> {
    public id = "EthnicitySearch";
    public ethnicities: EthnicityDropdownItem[] = [];

    constructor(ethnicities: EthnicityDropdownItem[]) {
        super();
        this.ethnicities = ethnicities;
    }

    public async executeSearch(searchText: string): Promise<EthnicityDropdownItem[]> {
        let results: EthnicityDropdownItem[] = [];
        if (!searchText) {
            results = this.ethnicities;
        }
        else {
            results = this.ethnicities
                .filter(item => new RegExp(searchText, "gi").test(item.Item.localKey))
                .sort((a, b) => a.Item.localKey.localeCompare(b.Item.localKey));
        }
        return new Promise((resolve => resolve(results)));
    }
}

export { EthnicitySearchAutocompleteCustom, EthnicitySearchSearchStrategy };
